import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import VideoPlayer from './VideoPlayer';
import knowledgeClips from "../../assets/logo/learningLounge/knowledgeClips.png";
import { trackEvent } from '../../utils/gaTracking';
import { useSelector } from 'react-redux';

function VideoContainer({playlist}) {
    const [show, setShow] = useState(false);
    const authState = useSelector((state) => state.authUser);
    const user_id = authState?.profile?.user_id;
    const user_email = authState?.profile?.email;

    return (
        <>
        <Modal
              className='momentsModal'
              show={show}
              size='xl'
              centered
              onHide={() => setShow(false)}
          keyboard={false}  
            >
              <Modal.Body>
                <VideoPlayer setShow={setShow} playlist={playlist} />
              </Modal.Body>
            </Modal>
        <div style={{ height: '100%', cursor: 'pointer' }} onClick={() => { trackEvent('hrd_knowledge_clips_viewed', 'HRD Knowledge Clips Viewed', 'HRD Knowledge Clips Viewed', 1, user_id, user_email); setShow(true) }}>
          <img src={knowledgeClips} alt='knowledgeClips' style={{ width: '100%', height: '155px', objectFit: 'contain' }} />
        </div>
        </>
    )
}

export default VideoContainer
